/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-09-10 19:14:41
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-06-26 14:09:53
 * @FilePath: \vue-hepha-order\src\views\stock\queryConfig\QueryForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const SwapQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 订单名称
            key:'order_name',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.orderName',
        },
        {
            // name:'stock.backNumber', // mes退货单号
            key:'back_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.backNumber',
        },
        {
            // name:'order.orderSource', // mes换货单号
            key:'swap_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'stock.swapNumber',
        },
        {
            // name:'order.deliverStatus', // 换货状态
            key:'status',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'stock.swapStatus',
            options:[
                {
                    value:1,
                    label:'order.swaping'
                },
                {
                    value:4,
                    label:'stock.outScanned'
                },
                {
                    value:2,
                    label:'order.exchangeSuccessful'
                },
                {
                    value:3,
                    label:'stock.cancelSwap2'
                },
            ]
        },
        {
            // name:'order.orderSource', // sku
            key:'sku',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'order.sku',
            options:[],
        },
        {
            // name:'order.erpNo', // SO
            key:'erp_no',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        {
            // name:'order.customerType', // 仓库
            key:'swap_inventory',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.warehouse',
            options:[]
        },
        // {
        //     // name:'order.customerType', // 物流公司
        //     key:'swap_courier_type',
        //     type:'select',
        //     allowClear:true,
        //     width:'260px',
        //     optionToLocale:true,
        //     placeholder:'order.courierType',
        //     options:[]
        // },
        {
            // name:'order.customerType', // 客户
            key:'customer_id',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.customerName',
            options:[]
        },
        {
            // name:'order.customerType', // 创建人
            key:'create_by',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        {
            // name:'order.customerType', // 物料类别
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'stock.categoryType',
            options:[]
        },
        {
            // name:'order.customerType', // 备注
            key:'remark',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.instruction',
        },
        {
            name:'', // 预计退货时间
            key:'back_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.planReturnStartDate',
            placeholder2:'stock.planReturnEndDate',
        },
        {
            name:'', // 实际退货时间
            key:'back_real_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.realReturnStartDate',
            placeholder2:'stock.realReturnEndDate',
        },
        {
            name:'', // 换货计划发出时间
            key:'swap_timestamp_plan',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.planShipStartDate',
            placeholder2:'stock.planShipEndDate',
        },
        {
            name:'', // 换货实际发出时间
            key:'swap_timestamp_real',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.realShipStartDate',
            placeholder2:'stock.realShipEndDate',
        },
        
    ]
}

const SwapEditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'280px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 寄出物流公司
            key:'swap_courier_type',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 寄出物流单号
            key:'swap_courier_no',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierLink', // 寄出物流链接
            key:'swap_courier_url',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierStatus', // 寄出物流状态
            key:'swap_courier_status',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    label:'order.shiped',
                    value:3,
                },
            ]
        },
        // {
        //     name:'stock.swapDateReal', // 实际发货时间
        //     key:'out_real_time',
        //     type:'date',
        //     showTime:false,
        //     allowClear:true,
        //     width:'260px',
        //     marginLeft:'40px'
        // },
        {
            name:'stock.cargoFreight', // 寄出运费
            key:'cargo_freight',
            type:'input',
            width:'260px',
            allowClear:true,
            prefix:true,
        },
    ]
}

const SwapEditForm2 = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'280px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 退回物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 退回物流单号
            key:'courier_no',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierLink', // 退回物流链接
            key:'courier_url',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
    ]
}

SwapQueryForm.formField.forEach(item=>{
    SwapQueryForm.formData[item.key] = ''
})

SwapEditForm.formField.forEach(item=>{
    SwapEditForm.formData[item.key] = ''
})

SwapEditForm2.formField.forEach(item=>{
    SwapEditForm2.formData[item.key] = ''
})


export {
    SwapQueryForm,
    SwapEditForm,
    SwapEditForm2,
}